const SubAbasProgEspecializado = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/programacao/especializado/ficha/${id}/dadosgerais`,
  },
  {
    label: 'Notificações',
    rota: `/secsaude/programacao/especializado/ficha/notificacoes`,
  },
];

export default SubAbasProgEspecializado;
